module.exports = __webpack_public_path__ + "assets/fonts/Icon-Staatsschulden.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Icon-Staatsschulden.svg
// module id = 525
// module chunks = 0